module.exports = __webpack_public_path__ + "img/img014.a0896909.png";